import React from 'react';

export const EmailIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect x='2.4' y='3.4' width='11.2' height='9.2' rx='1.4' stroke='currentColor' strokeWidth='1.2' />
        <path d='M3 4.1l5 3.9a1 1 0 001.2 0L14 4.1' stroke='currentColor' strokeWidth='1.2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
);

export const InstagramIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect x='2.6' y='2.6' width='10.8' height='10.8' rx='3.1' stroke='currentColor' strokeWidth='1.2' />
        <circle cx='8' cy='8' r='2.5' stroke='currentColor' strokeWidth='1.2' />
        <circle cx='11.5' cy='4.5' r='.75' fill='currentColor' />
    </svg>
);

export const TikTokIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M9.6 2.25h1.86c.14.92.7 1.74 1.52 2.2v1.69c-.86-.07-1.67-.39-2.36-.92v3.2c0 1.97-1.55 3.58-3.46 3.58-1.9 0-3.45-1.61-3.45-3.58S5.35 5.82 7.26 5.82c.3 0 .6.03.9.1v1.69c-.27-.1-.56-.15-.86-.15-.94 0-1.7.81-1.7 1.81 0 1 .76 1.82 1.7 1.82s1.7-.81 1.7-1.82V2.25Z'
            fill='currentColor'
        />
    </svg>
);

export const YouTubeIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect x='2' y='4' width='12' height='8' rx='2' stroke='currentColor' strokeWidth='1.2' />
        <path d='M6.5 6.5L10 8.5L6.5 10.5V6.5Z' fill='currentColor' />
    </svg>
);

export const CalendarIcon = () => (
    <svg width='14' height='14' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect x='2.5' y='3.5' width='11' height='10' rx='1.5' stroke='currentColor' strokeWidth='1' />
        <path d='M5 2.5v2M11 2.5v2M3 6.5h10' stroke='currentColor' strokeWidth='1' strokeLinecap='round' />
        <circle cx='8' cy='9.5' r='1.2' fill='currentColor' />
    </svg>
);

export const ManagerIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='8' cy='5.2' r='2.6' stroke='currentColor' strokeWidth='1.2' />
        <path d='M3.4 12.4c.7-2 2.4-3.4 4.6-3.4 2.2 0 3.9 1.4 4.6 3.4' stroke='currentColor' strokeWidth='1.2' strokeLinecap='round' />
    </svg>
);

export const RobotIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect x='3' y='4.2' width='10' height='6.6' rx='2' stroke='currentColor' strokeWidth='1.2' />
        <path d='M5.2 2.4V4.2M10.8 2.4V4.2' stroke='currentColor' strokeWidth='1.2' strokeLinecap='round' />
        <circle cx='6.6' cy='7.5' r='1' fill='currentColor' />
        <circle cx='9.4' cy='7.5' r='1' fill='currentColor' />
        <path d='M5.8 9.6c.5.6 1.2 1 2.2 1s1.7-.4 2.2-1' stroke='currentColor' strokeWidth='1.2' strokeLinecap='round' />
    </svg>
);

export const SendIcon = () => (
    <svg width='18' height='18' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M3.333 3.333L16.667 10 3.333 16.667l2.5-6.667-2.5-6.667z' stroke='currentColor' strokeWidth='1.6' strokeLinejoin='round' />
        <path d='M16.667 10H8.333' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' />
    </svg>
);

export const MoneyIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect x='1.8' y='3' width='12.4' height='10' rx='2' stroke='currentColor' strokeWidth='1.1' />
        <path
            d='M4.4 5.8c.5-.6 1.3-1 2.2-1h2.8c1.2 0 2.2.8 2.2 1.8s-1 1.8-2.2 1.8H7c-1.2 0-2.2.8-2.2 1.8 0 1 1 1.8 2.2 1.8h2.8'
            stroke='currentColor'
            strokeWidth='1.1'
            strokeLinecap='round'
        />
        <path d='M7.8 4.6v6.8' stroke='currentColor' strokeWidth='1.1' strokeLinecap='round' />
    </svg>
);

export const TimerIcon = () => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='10' cy='11' r='6.5' stroke='currentColor' strokeWidth='1.4' />
        <path d='M10 7V11.2L12.6 13' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M6.2 3.4H13.8' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' />
    </svg>
);

export const FacebookIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M9.5 2.5H11V0.5C11 0.5 10.2 0.5 9.3 0.5C7.4 0.5 6.2 1.8 6.2 3.8V5.5H4V8H6.2V15.5H8.8V8H11L11.4 5.5H8.8V4C8.8 3.2 9 2.5 9.5 2.5Z' fill='currentColor' />
    </svg>
);

export const PencilIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M11.2 2.8a1.4 1.4 0 0 1 2 2L5.6 12.4l-2.8.7.7-2.8L11.2 2.8z' stroke='currentColor' strokeWidth='1.2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
);

export const TrashIcon = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M3 4.5h10M6.5 4.5V3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1.5M5 4.5v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-8' stroke='currentColor' strokeWidth='1.2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
);
